module.exports = __webpack_public_path__ + "img/english.b05eed07.svg";